import React, { useContext, useEffect, useState } from "react";
import axios from "../../helper/axios";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import DashSidebar from "../../components/dashboard/DashSidebar";
import CreateUserForm from "./Users/CreateUserForm";
import UserCard from "./Users/UserCard";
import "../../../src/App.css";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [userLoading, setuserLoading] = useState(true);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const location = useLocation();

  const { token } = useContext(AuthContext);

  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await axios.get("/maitri_search_users", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = response.data.data;
      console.log(userData, "userData");
      setUsers(userData);
      setuserLoading(false);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleCreateUser = async (userData) => {
    try {
      const response = await axios.post("/maitri_register", userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const newUser = response.data.data;
      setUsers([...users, newUser]);
      fetchUserData();
      setShowAddUserModal(false);
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  const handleCloseCreateUserModal = () => {
    // You can add any logic here to reset form fields or perform other actions
    setShowAddUserModal(false);
  };

  const handleUpdateUser = async (userId, updatedUserData) => {
    try {
      const response = await axios.put(
        `/maitri_user_update/${userId}`,
        updatedUserData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const updatedUser = response.data;
      console.log(updatedUser, "updatedUser");
      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.user_id === updatedUser.user_id ? updatedUser : user
        )
      );
      fetchUserData();
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const handleDeleteUser = async (userId) => {
    if (window.confirm("Are you sure you want to Delete ?")) {
      try {
        await axios.delete(`/maitri_delete_user/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers((prevUsers) =>
          prevUsers.filter((user) => user.user_id !== userId)
        );
        alert("User Deleted Successfully");
      } catch (error) {
        console.error("Error deleting user:", error);
      }
    }
  };

  return (
    <>
      <section className="mt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-2">
              <DashSidebar activeClass={getActiveClass("/users")} />
            </div>
            <div className="col-sm-10 light-border p-4">
              <div className="control-btn-nav pb-3 row">
                <div className="col-sm-10">
                  <h3>
                    <b>Users</b>
                  </h3>
                </div>
                <div className="col-sm-2">
                  <button
                    className="btn btn__primary"
                    data-bs-toggle="modal"
                    data-bs-target="#addUserModal"
                  >
                    Create User
                  </button>
                  <CreateUserForm
                    onCreateUser={handleCreateUser}
                    onClose={handleCloseCreateUserModal}
                  />
                </div>
              </div>
              {userLoading ? (
                <>
                  <p>Loading Data...</p>
                </>
              ) : (
                <>
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Username</th>
                        <th scope="col">Email ID</th>
                        <th scope="col">User Type</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    {users.map((user, index) => (
                      <UserCard
                        key={user.user_id}
                        index={index + 1}
                        user={user}
                        onEdit={handleUpdateUser}
                        onDelete={handleDeleteUser}
                      />
                    ))}
                  </table>
                </>
              )}

              {/* {selectedUser && (
                <EditUserModal
                  id="editUserModal"
                  user={selectedUser}
                  onUpdateUser={handleUpdateUser}
                  onClose={() => setSelectedUser(null)}
                />
              )} */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Users;
